import { ApiClientResponse } from "@lib/ApiClient";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import {
    nudgesApplicationLoggerToken,
    nudgesRewardsAuthApiClientToken,
} from "../../tokens";
import { RewardsCustomerRewardsQueryParams } from "./query_params/RewardsCustomerRewardsQueryParams";

@singleton()
class NudgesCustomerActiveRewardsApiService {
    constructor(
        @inject(nudgesRewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface,
        @inject(nudgesApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    getCustomerActiveRewardsRequest(
        queryParams?: RewardsCustomerRewardsQueryParams
    ): Observable<ApiClientResponse<unknown>> {
        this.logger.debug(
            "NudgesRewardsCustomerRewardsApiService.getCustomerActiveRewards is started"
        );

        return this.apiClient.get({
            url: "/general/getCustomerActiveRewards",
            responseType: "json",
            queryParams,
        });
    }
}

export default NudgesCustomerActiveRewardsApiService;
